import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  getMessaging,
  isSupported,
  onMessage,
  getToken,
} from "firebase/messaging";
import {
  firebaseAppTBT,
  requestPermission,
  FCM_VAPID_KEY,
} from "../firebase";
import { TypesAction } from "../redux/typesAction";

function getNotificationPreview(remoteMessage: {
  data?: { [key: string]: string };
  notification?: { body?: string };
}): string {
  const text =
    remoteMessage.data?.body || remoteMessage.notification?.body || "";
  return text.trim() || "Bạn có thông báo mới";
}

/**
 * Registers FCM (token + foreground listener) when the browser supports it.
 * Cleans up the onMessage subscription on unmount.
 */
export function useFirebaseMessaging() {
  const dispatch = useDispatch();

  useEffect(() => {
    let cancelled = false;
    let unsubscribeOnMessage: (() => void) | undefined;

    (async () => {
      const supported = await isSupported();
      if (!supported || cancelled) return;

      await requestPermission();
      if (cancelled) return;

      const messaging = getMessaging(firebaseAppTBT);

      try {
        const token = await getToken(messaging, { vapidKey: FCM_VAPID_KEY });
        if (!cancelled && token) {
          dispatch({
            type: TypesAction.TOKEN_PUSH,
            payload: token,
          });
        }
      } catch (e) {
        if (process.env.NODE_ENV === "development") {
          console.warn("[FCM] getToken failed", e);
        }
      }

      if (cancelled) return;

      unsubscribeOnMessage = onMessage(messaging, (remoteMessage) => {
        toast.success(`Thông báo: ${getNotificationPreview(remoteMessage)}`);
      });
    })();

    return () => {
      cancelled = true;
      unsubscribeOnMessage?.();
    };
  }, [dispatch]);
}
